import React from "react";
import FileUpload, { UploadedFileInfo } from "./FileUpload";
import {
  Dialog,
  DialogType
} from "@fluentui/react/lib/Dialog";
import styled from "styled-components/macro";
import { forMinWidth } from "../../../theme/breakpoints";

export interface FileUploadProps {
  isOpen: boolean;
  nodeTrackingId: string;
  nodeAnswerHubId?: number;
  attachImage: boolean;
  approvedFileExtensions?: string;

  onUploaded: (files: UploadedFileInfo[]) => void;
  onDismiss: () => void;
}

export default function FileUploadDialog(props: FileUploadProps): JSX.Element {
  return <Wrapper
    hidden={!props.isOpen}
    dialogContentProps={{
      showCloseButton: true,
      type: DialogType.close
    }}
    onDismiss={props.onDismiss}
    title={`Choose ${props.attachImage ? 'an image' : 'a file'} to upload`}
  >
    <FileUpload
      nodeTrackingId={props.nodeTrackingId}
      nodeAnswerHubId={props.nodeAnswerHubId}
      attachImage={props.attachImage}
      approvedFileExtensions={props.approvedFileExtensions}
      onUploaded={props.onUploaded}
      onDismiss={props.onDismiss}
    />
  </Wrapper>
}

const Wrapper = styled(Dialog)`
  .ms-Dialog-main {
    min-width: 30rem;

    ${forMinWidth.sm`
      min-width: 45rem;
    `}

    ${forMinWidth.md`
      min-width: 60rem;
    `}
  }
`;
